export default __webpack_public_path__ + "a5484623f6f22b96c23cdbefce76d24b.svg";